/* FAQ — five questions photographers ask before signing up. */

import { Reveal } from "./Reveal";

export default function FaqSection() {
  const faqs = [
    {
      q: "How is this different from HoneyBook or Dubsado?",
      a: "Those are CRMs that bolt galleries on as an afterthought. Lumetier is built around the gallery and the client experience — the part of your business that actually wins referrals.",
    },
    {
      q: "Can I import my existing clients from Pixieset / HoneyBook?",
      a: "Yes. CSV import for clients & bookings is included on every tier. Gallery migrations from Pixieset are hands-on — I'll personally help charter members move their last 6 months of galleries over.",
    },
    {
      q: "How do my clients pay? Do they need accounts?",
      a: "Zelle, Stripe, and Venmo on day one (PayPal coming). Clients open their gallery/booking with a password I auto-generate for you — no accounts to create, no apps to download, no friction.",
    },
    {
      q: "What if I outgrow it? Can I export my data?",
      a: "Always. Full data export (clients, bookings, contracts, photos) on demand from the admin. Your work is yours. We make money by being good enough that you stay — not by locking you in.",
    },
    {
      q: "How do I get an invite?",
      a: "Send me an application below — name, email, what kind of photography you do. I'll personally email you a private onboarding link within 48 hours. Lumetier is free for accepted photographers while we're early.",
    },
  ];

  return (
    <section className="border-t border-white/[0.07] py-28" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6">
        <Reveal>
          <div className="text-center mb-12">
            <div className="text-[11px] uppercase tracking-[0.32em] text-stone-500 mb-5">Honest answers</div>
            <h2
              className="text-4xl md:text-5xl font-light text-stone-100"
              style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
            >
              The questions photographers ask{" "}
              <em className="italic text-stone-400">before</em> they sign up.
            </h2>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="space-y-3">
            {faqs.map((f, i) => (
              <details
                key={f.q}
                className="group bg-white/[0.03] border border-white/[0.08] open:border-white/[0.18] transition-colors"
                data-testid={`faq-${i}`}
              >
                <summary
                  className="cursor-pointer list-none px-6 py-5 flex items-center justify-between gap-4 text-stone-100"
                >
                  <span className="text-base sm:text-lg font-light"
                        style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
                    {f.q}
                  </span>
                  <span
                    className="shrink-0 w-7 h-7 inline-flex items-center justify-center border border-white/[0.15] text-stone-400 group-open:text-stone-100 group-open:border-white/[0.3] transition-colors"
                    aria-hidden="true"
                  >
                    <span className="relative w-3 h-3 inline-block">
                      <span className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-px bg-current" />
                      <span className="absolute inset-y-0 left-1/2 -translate-x-1/2 w-px bg-current group-open:opacity-0 transition-opacity" />
                    </span>
                  </span>
                </summary>
                <div className="px-6 pb-6 -mt-1 text-sm text-stone-400 leading-relaxed">
                  {f.a}
                </div>
              </details>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="text-center mt-12 text-xs text-stone-500">
            Still wondering? Email{" "}
            <a href="mailto:hello@lumetiercreatives.com" className="underline hover:text-stone-300">
              hello@lumetiercreatives.com
            </a>
            {" "}— I read every one.
          </div>
        </Reveal>
      </div>
    </section>
  );
}
